(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("_"));
	else if(typeof define === 'function' && define.amd)
		define(["_"], factory);
	else if(typeof exports === 'object')
		exports["quotekchart"] = factory(require("_"));
	else
		root["quotekchart"] = factory(root["_"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__34__) {
return 